import { createContext } from "react";

interface RefreshModalContextType {
  showModal: () => void;
  hideModal: () => void;
}

export const RefreshModalContext =
  createContext<RefreshModalContextType | null>(null);
